import { render, staticRenderFns } from "./DevDocsModal.Style#Drawer.vue?vue&type=template&id=8ba506f8&scoped=true&"
import script from "./DevDocsModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./DevDocsModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./DevDocsModal.Style#Drawer.vue?vue&type=style&index=0&id=8ba506f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba506f8",
  null
  
)

export default component.exports